export const PermissionConst = [
    {idSelect: 0, descriptionData: 'view'},
    {idSelect: 2, descriptionData: 'create'},
    {idSelect: 5, descriptionData: 'create_delete_edit'},
]

export enum PermissionEnum {
    VIEW = 0,
    EDIT = 1,
    CREATE = 2,
    DELETE = 3,
    CREATE_DELETE = 4,
    CREATE_DELETE_EDIT = 5
}

export enum RolEnum {
    ADMIN = 0,
    USER = 1
}
